import { useTenantStore } from '../stores/TenantStore';
import { Typography, Button, Alert, AlertTitle, Grid, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import QRCodeCard from './shared/QRCodeCard';
import CloseButton from './shared/CloseButton';
import { useEffect, useState } from 'react';

const underlinedTitleStyle = {
    position: 'relative',
    margin: 0,
    '&::after': {
        content: '""',
        position: 'absolute',
        bottom: -2,
        left: '50%',
        transform: 'translateX(-50%)',
        width: '100%',
        height: '5px',
        backgroundColor: 'primary.main',
        borderRadius: 5
    }
}

function useWindowHeight() {
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => setHeight(window.innerHeight);

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return height;
}

const QRViewerCard = ({ onLinkClicked }: { onLinkClicked: () => void }) => {
    const { tenant, updateActiveState, setIsRequestPending
    } = useTenantStore();
    const handleCloseQRCodeViewer = () => {
        updateActiveState("emptyResponse")
        setIsRequestPending(true)
    }
    const height = useWindowHeight();
    const hideOnSmallHeight = height < 800;

    return (
        tenant.urlInfo?.view === 'qrCode' ?
            <Grid container
                direction="column"
                justifyContent="space-between"
                alignItems="center"
                height="100%"
                sx={{
                    maxHeight: 950,
                }}
                px={{ sm: 5 }}
                spacing={1}>
                    <Box style={{ position: "absolute", top: 10, right: 10 }}>
                    <CloseButton onClick={handleCloseQRCodeViewer}/>
                    </Box>
                <Grid item>
                    <Typography
                        variant="h3"
                        align="center"
                        gutterBottom
                        color="text.primary"
                        sx={underlinedTitleStyle}
                    >
                        {tenant.urlInfo.title}
                    </Typography>
                    <Grid item sx={{ display: { xs: 'none', md: hideOnSmallHeight ? 'none' : 'block' } }}>
                        <Alert
                            icon={<InfoIcon fontSize="inherit" />}
                            severity="info"
                        >
                            <AlertTitle>
                                <Typography variant='h5'>
                                    Hilfe
                                </Typography>
                            </AlertTitle>
                            <Typography variant="body1">
                                Sie können schnell und einfach auf die gewünschte Website zugreifen, indem Sie den unten angezeigten QR-Code mit Ihrer Handykamera scannen. Alternativ können Sie auch den Link direkt auf diesem Gerät öffnen, um Ihre Eingaben vorzunehmen.
                            </Typography>
                        </Alert>
                    </Grid>
                </Grid>

                <Grid item>
                    <QRCodeCard value={tenant.urlInfo.url}>
                        {(tenant.urlInfo.label || tenant.urlInfo.text) &&
                            <Box display="flex"
                                mt={2}
                                flexDirection="column"
                                height="100%"
                                sx={{ textTransform: "uppercase", fontSize: 20, fontWeight: "bold" }}
                            >

                                <Typography color="textSecondary" sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
                                    {tenant.urlInfo.label}
                                </Typography>


                                <Typography color="textPrimary" ml={1} sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
                                    {tenant.urlInfo.text}
                                </Typography>

                            </Box >}
                    </QRCodeCard>
                </Grid>

                <Grid item style={{ width: "70%" }}>
                    <Button size='large' variant="contained" color="primary" fullWidth onClick={onLinkClicked}>
                        Hier öffnen (Open)
                    </Button>
                </Grid>
            </Grid> :
            <></>
    );
};

export default QRViewerCard;
